import createHashSource from "hash-source";
import { createHistory, HistorySource } from "@reach/router";

const source = createHashSource();

export const history = createHistory(source as HistorySource);

export const { navigate } = history;
